
export const getFieldValue = (field) => {
    if (
        field &&
        typeof field !== 'object'
    ) {
        return field;
    } else if (
        field &&
        typeof field === 'object' &&
        Object.keys(field).includes('value')
    ) {
        return field.value;
    }
    if (field === 0 || field === '') {
        return field;
    }
    return null;
};
